export default __webpack_public_path__ + "static/media/cbh-logo.09e46631.png";